import { useDeviceType } from '@cian/ui-kit';
import { useState, useEffect, useRef } from 'react';

export const VIDEO_HEIGHTS = {
  desktop: 596,
  tablet: 328,
  phone: 300,
};

export const useVideoSize = () => {
  const [width, setWidth] = useState(0);
  const sliderRef = useRef<HTMLDivElement>(null);
  const device = useDeviceType();

  useEffect(() => {
    const updateSize = () => {
      if (sliderRef.current) {
        const { width } = sliderRef.current.getBoundingClientRect();

        setWidth(width);
      }
    };

    updateSize();

    window.addEventListener('resize', updateSize);

    return () => {
      window.removeEventListener('resize', updateSize);
    };
  }, [sliderRef]);

  return { width, height: VIDEO_HEIGHTS[device], ref: sliderRef };
};
